import { FC, useMemo, useState } from 'react';

import { twMerge } from 'tailwind-merge';
import { DistributionChannelConnector } from '@/models/distributionChannels';
import { DestinationItem } from './DestinationItem';
import { useTranslation } from 'react-i18next';

type DataDestinationsGridProps = {
  dataDestinations: DistributionChannelConnector[];
  className?: string;
};

export const DataDestinationsGrid: FC<DataDestinationsGridProps> = ({ dataDestinations, className }) => {
  const { t } = useTranslation('COMMON');
  const [selectedDisconnectedConnector, setSelectedDisconnectedConnector] = useState<DistributionChannelConnector | null>(null);

  const handleSelectConnector = (connector: DistributionChannelConnector | null) => {
    setSelectedDisconnectedConnector((prev) => (connector === prev ? null : connector));
  };

  const [connectedConnector, disconnectedConnector] = useMemo(() => {
    return dataDestinations.reduce(
      ([connected, disconnected], connector) =>
        connector.installed && connector.authenticated
          ? [[...connected, connector], disconnected]
          : [connected, [...disconnected, connector]],
      [[], []]
    );
  }, [dataDestinations]);

  return (
    <>
      <p className='p-4 first-letter:uppercase text-base font-semibold text-brand-600'>{t("highlighted")}</p>

      {
        connectedConnector.length > 0 &&
        <div className={twMerge(`flex flex-wrap gap-4 justify-start py-4`, className)}>
          {connectedConnector.map((connector) => (
            <DestinationItem
              key={connector.name}
              connector={connector}
              selectedDisconnectedConnector={selectedDisconnectedConnector}
              onSelectedDisconnectedConnector={handleSelectConnector}
            />
          ))}
        </div>
      }
      {
        disconnectedConnector.length > 0 && 
        <div className={twMerge(`flex flex-wrap gap-4 justify-star py-4 border-t`, className)}>
          {disconnectedConnector.map((connector) => (
            <DestinationItem
              key={connector.name}
              connector={connector}
              selectedDisconnectedConnector={selectedDisconnectedConnector}
              onSelectedDisconnectedConnector={handleSelectConnector}
            />
          ))}
      </div>
      }
    </>
  );
};